import { Controller } from "remult";

@Controller("future-notification-methods")
export class FutureNotificationMethods {}
